import { c as _c } from "react/compiler-runtime";
import { EmailComposerContext } from "../context";
import type { NodeViewProps } from "@tiptap/react";
import { NodeViewWrapper } from "@tiptap/react";
import { useContext } from "react";
import { cx } from "@/lib/tailwind-utils";
export function EmailMentionComponent(props) {
  const $ = _c(6);
  const context = useContext(EmailComposerContext);
  const id = props.node.attrs.id as string | undefined;
  const variables = context?.variables ?? [];
  const isUnresolvable = variables.length > 0 && !!id && !variables.some(v => v.id === id);
  const t0 = isUnresolvable ? "This value won't fill in here \u2014 it isn't available on this screen." : undefined;
  const t1 = isUnresolvable ? "bg-status-error-bg text-status-error-text ring-1 ring-status-error-text/40" : "bg-primary/10 text-primary";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("rounded-sm px-1 py-px text-[length:inherit] font-medium", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = props.node.attrs.label ?? id;
  let t4;
  if ($[2] !== t0 || $[3] !== t2 || $[4] !== t3) {
    t4 = <NodeViewWrapper as="span" className="inline w-fit"><span title={t0} className={t2}>@{t3}</span></NodeViewWrapper>;
    $[2] = t0;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}